import React from "react";
import { Notification, NotificationEvents } from "@lib/types/Notification";
import CustomerPayBillRequestLogo from "./CustomerPayBillRequestLogo";
import ScannedTransactionFoundLogo from "./ScannedTransactionFoundLogo";
import CustomerTransactionRequestLogo from "./CustomerTransactionRequestLogo";
import CustomerManualTransactionRequestLogo from "./CustomerManualTransactionRequestLogo";

export type NotificationLogoProps = {
  notification: Notification;
  size?: "large" | "small";
  onlyIcon?: boolean;
};

const NotificationLogo: React.FC<NotificationLogoProps> = (props) => {
  switch (props?.notification?.event) {
    case NotificationEvents.CustomerPayBillRequest:
      return <CustomerPayBillRequestLogo {...props} />;
    case NotificationEvents.ScannedTransactionFound:
      return <ScannedTransactionFoundLogo {...props} />;
    case NotificationEvents.CustomerTransactionRequest:
      return <CustomerTransactionRequestLogo {...props} />;
    case NotificationEvents.CustomerManualTransactionRequest:
      return <CustomerManualTransactionRequestLogo {...props} />;

    default:
      return "Unknown event text";
  }
};

export default NotificationLogo;

export {
  CustomerPayBillRequestLogo,
  ScannedTransactionFoundLogo,
  CustomerTransactionRequestLogo,
  CustomerManualTransactionRequestLogo,
};
